/* eslint-disable no-underscore-dangle */

import { isActuatingGripper } from '@sb/integrations/utils';
import { FailureKind } from '@sb/routine-runner/FailureKind';
import type { StepPlayArguments } from '@sb/routine-runner/Step/Step';
import Step from '@sb/routine-runner/Step/Step';
import { wait } from '@sb/utilities';

import { DisableGripperArguments as Arguments } from './Arguments';
import { DisableGripperVariables as Variables } from './Variables';

export class DisableGripperStep extends Step<Arguments, Variables> {
  public static areSubstepsRequired = false;

  public static Arguments = Arguments;

  public static Variables = Variables;

  public initializeVariableState(): void {
    this.variables = {
      succeeded: false,
    };
  }

  public async _play({ fail }: StepPlayArguments): Promise<void> {
    const { payload } = this.args;

    this.setVariable('succeeded', false);

    const equipmentState = this.routineContext.equipment.getEquipmentState();

    const enabledGripper = equipmentState.find((item) =>
      isActuatingGripper(item.kind),
    );

    if (enabledGripper == null) {
      return fail({
        failure: {
          kind: FailureKind.GripperFailure,
          message: `No enabled gripper found. Cannot disable a gripper when there is no enabled gripper.`,
        },
        failureReason: `No enabled gripper found. Cannot disable a gripper when there is no enabled gripper.`,
      });
    }

    try {
      await this.routineContext.equipment.disableEquipment(enabledGripper.id);
      // We wait for 500ms to ensure the gripper state has time to update
      await wait(500);
    } catch (error) {
      return fail({
        failure: {
          kind: FailureKind.GripperFailure,
          message: `Failed to disable gripper: ${error.message}`,
        },
        failureReason: `Failed to disable gripper: ${error.message}`,
        error,
      });
    }

    if (payload) {
      await this.routineContext.setPayload(payload);
    }

    this.setVariable('succeeded', true);

    return undefined;
  }
}
